import React, { useEffect, useState } from 'react';

const QuestWeekCountdown = ({ weekEndDate, weekCompleted = false, onWeekReset }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [lastTimeLeft, setLastTimeLeft] = useState('');

  const getTimeUntilWeekEnd = () => {
    if (!weekEndDate) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    const now = new Date();
    const endOfWeek = new Date(weekEndDate);
    endOfWeek.setHours(23, 59, 59, 999); // Set to end of day

    const msUntilWeekEnd = endOfWeek.getTime() - now.getTime();

    if (msUntilWeekEnd <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(msUntilWeekEnd / (1000 * 60 * 60 * 24));
    const hours = Math.floor((msUntilWeekEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((msUntilWeekEnd % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((msUntilWeekEnd % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  };

  const formatTimeUntilWeekEnd = () => {
    const { days, hours, minutes, seconds } = getTimeUntilWeekEnd();

    if (days > 0) {
      return `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } else {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  };

  useEffect(() => {
    const updateTimer = () => {
      const newTimeLeft = formatTimeUntilWeekEnd();

      // Check if we just crossed the week boundary (time reset from small value to large value)
      if (
        (lastTimeLeft && lastTimeLeft.startsWith('00:00:0') && newTimeLeft.includes('d')) ||
        (newTimeLeft.startsWith('6d') && lastTimeLeft.startsWith('00:00:0'))
      ) {
        // Trigger refresh callback when week reset is detected
        if (onWeekReset) {
          setTimeout(() => {
            onWeekReset();
          }, 1000); // Small delay to ensure new week has started
        }
      }

      setLastTimeLeft(timeLeft);
      setTimeLeft(newTimeLeft);
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, lastTimeLeft, onWeekReset, weekEndDate]);

  if (weekCompleted) {
    return (
      <div className="inline-flex items-center">
        <div className="bg-green-50 border border-green-200 rounded-md px-2 py-1 inline-flex items-center gap-2">
          <span className="text-xs text-green-600">🎉 Week completed!</span>
          <span className="text-sm font-mono font-bold text-green-600">{timeLeft}</span>
        </div>
      </div>
    );
  }

  const { days } = getTimeUntilWeekEnd();
  const isLastDay = days === 0;

  return (
    <div className="inline-flex items-center">
      <div
        className={`border rounded-md px-2 py-1 inline-flex items-center gap-2 ${
          isLastDay ? 'bg-red-50 border-red-200' : 'bg-blue-50 border-blue-200'
        }`}
      >
        <span className={`text-xs ${isLastDay ? 'text-red-600' : 'text-gray-600'}`}>
          ⏰ Week ends in:
        </span>
        <span
          className={`text-sm font-mono font-bold ${isLastDay ? 'text-red-600' : 'text-blue-600'}`}
        >
          {timeLeft}
        </span>
      </div>
    </div>
  );
};

export default QuestWeekCountdown;
